import Admins from './Admins';

export default Admins;